import styles from './header.module.scss';
import cn from 'classnames';
import { ReactComponent as BackButton } from "@assets/images/Fireboard/BackButton.svg";

const HamHeader = (props) => {
    const { label, onClickback, filterElement } = props;

    return (
        <div className={cn(styles.hamHeader, 'col-12 d-flex align-items-center justify-content-between')}>
            <div className="d-flex align-items-center col-6 px-0">
                <span
                    className={cn("d-flex justify-content-center align-items-center position-relative", styles.BackIcon)}
                    onClick={onClickback}
                >
                    <BackButton />
                </span>
                <span className={cn('fs-16 fw-500 pl-3', styles.headerLabel)}>{label}</span>
            </div>

            {filterElement && <div className="d-flex justify-content-end align-items-center col-6 px-0">
                {filterElement()}
            </div>}
        </div>

    );
};

export default HamHeader;
